import React, { useState, useEffect } from "react";
import { updateConfig, deleteBackground } from "../api/adminApi";
import { useSettings } from "../../hooks/useSettings";
import { API_BASE_URL } from "../../config/api";

const SiteSettings = () => {
  const [desktopHomeBg, setDesktopHomeBg] = useState(null);
  const [desktopGalleryBg, setDesktopGalleryBg] = useState(null);
  const [desktopDetailsBg, setDesktopDetailsBg] = useState(null);
  const [mobileBg, setMobileBg] = useState(null);
  const [mobileGalleryBg, setMobileGalleryBg] = useState(null);
  const [mobileDetailsBg, setMobileDetailsBg] = useState(null);
  const [previewDesktopHome, setPreviewDesktopHome] = useState(null);
  const [previewDesktopGallery, setPreviewDesktopGallery] = useState(null);
  const [previewDesktopDetails, setPreviewDesktopDetails] = useState(null);
  const [previewMobile, setPreviewMobile] = useState(null);
  const [previewMobileGallery, setPreviewMobileGallery] = useState(null);
  const [previewMobileDetails, setPreviewMobileDetails] = useState(null);
  const { settings, loading } = useSettings();

  // Carica le immagini salvate all'avvio
  useEffect(() => {
    if (settings) {
      setPreviewDesktopHome(
        settings.desktopBackgroundPath
          ? `${API_BASE_URL}${settings.desktopBackgroundPath}`
          : null,
      );
      setPreviewDesktopGallery(
        settings.desktopGalleryBackgroundPath
          ? `${API_BASE_URL}${settings.desktopGalleryBackgroundPath}`
          : null,
      );
      setPreviewDesktopDetails(
        settings.desktopDetailsBackgroundPath
          ? `${API_BASE_URL}${settings.desktopDetailsBackgroundPath}`
          : null,
      );
      setPreviewMobile(
        settings.mobileBackgroundPath
          ? `${API_BASE_URL}${settings.mobileBackgroundPath}`
          : null,
      );
      setPreviewMobileGallery(
        settings.mobileGalleryBackgroundPath
          ? `${API_BASE_URL}${settings.mobileGalleryBackgroundPath}`
          : null,
      );

      setPreviewMobileDetails(
        settings.mobileDetailsBackgroundPath
          ? `${API_BASE_URL}${settings.mobileDetailsBackgroundPath}`
          : null,
      );
    }
  }, [settings]);

  // Gestione caricamento file
  const handleDesktopHomeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDesktopHomeBg(file);
      setPreviewDesktopHome(URL.createObjectURL(file));
    }
  };

  const handleDesktopGalleryChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDesktopGalleryBg(file);
      setPreviewDesktopGallery(URL.createObjectURL(file));
    }
  };

  const handleDesktopDetailsChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDesktopDetailsBg(file);
      setPreviewDesktopDetails(URL.createObjectURL(file));
    }
  };

  const handleMobileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMobileBg(file);
      setPreviewMobile(URL.createObjectURL(file));
    }
  };

  const handleMobileGalleryChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMobileGalleryBg(file);
      setPreviewMobileGallery(URL.createObjectURL(file));
    }
  };

  const handleMobileDetailsChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMobileDetailsBg(file);
      setPreviewMobileDetails(URL.createObjectURL(file));
    }
  };

  // Funzione per eliminare un'immagine
  const handleDelete = async (fieldName) => {
    try {
      const data = await deleteBackground(fieldName);
      if (data.success) {
        alert(`Immagine ${fieldName} eliminata!`);
        //refreshSettings(); // Aggiorna i dati dopo l'eliminazione
        // Reimposta la preview
        switch (fieldName) {
          case "desktopBackgroundPath":
            setPreviewDesktopHome(null);
            break;
          case "desktopGalleryBackgroundPath":
            setPreviewDesktopGallery(null);
            break;
          case "desktopDetailsBackgroundPath":
            setPreviewDesktopDetails(null);
            break;
          case "mobileBackgroundPath":
            setPreviewMobile(null);
            break;
          case "mobileGalleryBackgroundPath":
            setPreviewMobileGallery(null);
            break;
          case "mobileDetailsBackgroundPath":
            setPreviewMobileDetails(null);
            break;
          default:
            break;
        }
      } else {
        console.error("Errore:", data.message);
      }
    } catch (error) {
      console.error("Errore:", error);
    }
  };

  // Funzione per salvare le impostazioni
  const handleSave = async () => {
    const formData = new FormData();
    if (desktopHomeBg) formData.append("desktopHomeBg", desktopHomeBg);
    if (mobileBg) formData.append("mobileBg", mobileBg);
    if (desktopGalleryBg) formData.append("desktopGalleryBg", desktopGalleryBg);
    if (desktopDetailsBg) formData.append("desktopDetailsBg", desktopDetailsBg);
    if (mobileGalleryBg) formData.append("mobileGalleryBg", mobileGalleryBg);
    if (mobileDetailsBg) formData.append("mobileDetailsBg", mobileDetailsBg);

    const data = await updateConfig(formData);
    if (data.success) {
      alert("Paramètres enregistrés !");
      //refreshSettings(); // Aggiorna i dati dopo il salvataggio
    } else {
      console.error("Errore:", data.message);
    }
  };

  if (loading) return <div>Caricamento...</div>;

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #00ff00",
        borderRadius: "5px",
        backgroundColor: "#111",
        color: "#00ff00",
        fontFamily: '"Courier New", monospace',
      }}
    >
      <h2 style={{ color: "#ff0", borderBottom: "1px solid #00ff00" }}>
        Paramètres du site
      </h2>

      {/* Desktop Home */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Background Desktop HomePage</h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleDesktopHomeChange}
            style={{
              color: "#00ff00",
              backgroundColor: "#333",
              padding: "5px",
              border: "1px solid #00ff00",
              borderRadius: "3px",
            }}
          />
          {settings?.desktopBackgroundPath && (
            <button
              onClick={() => handleDelete("desktopBackgroundPath")}
              style={{
                backgroundColor: "#ff0000",
                color: "#fff",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                fontFamily: '"Courier New", monospace',
                height: "30px",
                whiteSpace: "nowrap",
              }}
            >
              Supprimer
            </button>
          )}
        </div>
        {previewDesktopHome && (
          <img
            src={previewDesktopHome}
            alt="Anteprima desktop home"
            style={{
              maxWidth: "100%",
              maxHeight: "200px",
              border: "1px solid #00ff00",
              marginTop: "10px",
            }}
          />
        )}
      </div>

      {/* Desktop Gallery */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Background Desktop Gallery</h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleDesktopGalleryChange}
            style={{
              color: "#00ff00",
              backgroundColor: "#333",
              padding: "5px",
              border: "1px solid #00ff00",
              borderRadius: "3px",
            }}
          />
          {settings?.desktopGalleryBackgroundPath && (
            <button
              onClick={() => handleDelete("desktopGalleryBackgroundPath")}
              style={{
                backgroundColor: "#ff0000",
                color: "#fff",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                fontFamily: '"Courier New", monospace',
                height: "30px",
                whiteSpace: "nowrap",
              }}
            >
              Supprimer
            </button>
          )}
        </div>
        {previewDesktopGallery && (
          <img
            src={previewDesktopGallery}
            alt="Anteprima desktop gallery"
            style={{
              maxWidth: "100%",
              maxHeight: "200px",
              border: "1px solid #00ff00",
              marginTop: "10px",
            }}
          />
        )}
      </div>

      {/* Desktop Details */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Background Desktop Details</h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleDesktopDetailsChange}
            style={{
              color: "#00ff00",
              backgroundColor: "#333",
              padding: "5px",
              border: "1px solid #00ff00",
              borderRadius: "3px",
            }}
          />
          {settings?.desktopDetailsBackgroundPath && (
            <button
              onClick={() => handleDelete("desktopDetailsBackgroundPath")}
              style={{
                backgroundColor: "#ff0000",
                color: "#fff",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                fontFamily: '"Courier New", monospace',
                height: "30px",
                whiteSpace: "nowrap",
              }}
            >
              Supprimer
            </button>
          )}
        </div>
        {previewDesktopDetails && (
          <img
            src={previewDesktopDetails}
            alt="Anteprima desktop details"
            style={{
              maxWidth: "100%",
              maxHeight: "200px",
              border: "1px solid #00ff00",
              marginTop: "10px",
            }}
          />
        )}
      </div>
      <div style={{ width: "100%", display : "flex", justifyContent : "center"}}>
        <h2>Mobile</h2>
      </div>
      
      {/* Mobile */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Background Mobile</h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleMobileChange}
            style={{
              color: "#00ff00",
              backgroundColor: "#333",
              padding: "5px",
              border: "1px solid #00ff00",
              borderRadius: "3px",
            }}
          />
          {settings?.mobileBackgroundPath && (
            <button
              onClick={() => handleDelete("mobileBackgroundPath")}
              style={{
                backgroundColor: "#ff0000",
                color: "#fff",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                fontFamily: '"Courier New", monospace',
                height: "30px",
                whiteSpace: "nowrap",
              }}
            >
              Supprimer
            </button>
          )}
        </div>
        {previewMobile && (
          <img
            src={previewMobile}
            alt="Anteprima mobile"
            style={{
              maxWidth: "100%",
              maxHeight: "200px",
              border: "1px solid #00ff00",
              marginTop: "10px",
            }}
          />
        )}

        <div style={{ marginBottom: "20px" }}>
          <h3>Background Mobile Gallery</h3>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <input
              type="file"
              accept="image/*"
              onChange={handleMobileGalleryChange}
              style={{
                color: "#00ff00",
                backgroundColor: "#333",
                padding: "5px",
                border: "1px solid #00ff00",
                borderRadius: "3px",
              }}
            />
            {settings?.mobileGalleryBackgroundPath && (
              <button
                onClick={() => handleDelete("mobileGalleryBackgroundPath")}
                style={{
                  backgroundColor: "#ff0000",
                  color: "#fff",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  fontFamily: '"Courier New", monospace',
                  height: "30px",
                  whiteSpace: "nowrap",
                }}
              >
                Supprimer
              </button>
            )}
          </div>
          {previewMobileGallery && (
            <img
              src={previewMobileGallery}
              alt="Preview mobile gallery"
              style={{
                maxWidth: "100%",
                maxHeight: "200px",
                border: "1px solid #00ff00",
                marginTop: "10px",
              }}
            />
          )}
        </div>
         <div style={{ marginBottom: "20px" }}>
          <h3>Background Mobile Details</h3>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <input
              type="file"
              accept="image/*"
              onChange={handleMobileDetailsChange}
              style={{
                color: "#00ff00",
                backgroundColor: "#333",
                padding: "5px",
                border: "1px solid #00ff00",
                borderRadius: "3px",
              }}
            />
            {settings?.mobileDetailsBackgroundPath && (
              <button
                onClick={() => handleDelete("mobileDetailsBackgroundPath")}
                style={{
                  backgroundColor: "#ff0000",
                  color: "#fff",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  fontFamily: '"Courier New", monospace',
                  height: "30px",
                  whiteSpace: "nowrap",
                }}
              >
                Supprimer
              </button>
            )}
          </div>
          {previewMobileDetails && (
            <img
              src={previewMobileDetails}
              alt="Preview mobile gallery"
              style={{
                maxWidth: "100%",
                maxHeight: "200px",
                border: "1px solid #00ff00",
                marginTop: "10px",
              }}
            />
          )}
        </div>
        {/*  */}
      </div>

      {/* Bottone di salvataggio */}
      <button
        onClick={handleSave}
        style={{
          backgroundColor: "#00ff00",
          color: "#000",
          border: "none",
          padding: "10px 20px",
          fontFamily: '"Courier New", monospace',
          cursor: "pointer",
          marginTop: "10px",
        }}
      >
        Sauvegarder
      </button>
    </div>
  );
};

export default SiteSettings;
